import { render, staticRenderFns } from "./MedicalAlertFloatBtns.vue?vue&type=template&id=585b6f6e&"
import script from "./MedicalAlertFloatBtns.vue?vue&type=script&lang=js&"
export * from "./MedicalAlertFloatBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports